import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-radio',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  <div  *ngFor="let option of to.options | formlySelectOptions: field | async">
    <ejs-radiobutton
     
      [formControl]="$any(formControl)"
      [label]="option.label"
      [value]="option.value"
      [name]="field.name || id"
      cssClass="e-success"
      [class.ng-dirty]="showError"
      (onChange)="to.change && to.change(field, $event)"
    ></ejs-radiobutton>
    <p class="my-[10px] ml-[24px] opacity-60" *ngIf="props['metadata']?.[option.value]">
        {{ props['metadata']?.[option.value] }}
      </p>  
  </div>
  `,
  styles: [
    `
      :host {
        display: grid;
        gap: 6px;
      }
    `
  ]
})
export class FormlyFieldRadio extends FieldType {
  // TODO: WHY?
  defaultOptions = {
    props: { options: [], medata: {} },
  };
  toggle() {
    this.formControl.setValue(!this.formControl.value);
  }
}
